"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionTokenStorage = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _TokenSessionStorageKeys = require("../TokenSessionStorageKeys");
var _constants = require("../constants");
var _AuthCookies = require("../internals/AuthCookies");
var _SessionValue = require("./SessionValue");
// Checks if auth cookie value satisfies new cookie value format as previously auth cookie included only date of expiration instead of new tenant\consultant-number format
const isNewAuthCookie = cookieValue => typeof cookieValue === 'string' && /[a-z]{2,}\\\d+/i.test(cookieValue);
class SessionTokenStorage {
  constructor(tokenStorageKey = _TokenSessionStorageKeys.TokenSessionStorageKeys.USER_ACCESS) {
    // FIXME: Mark as private!
    (0, _defineProperty2.default)(this, "token", void 0);
    (0, _defineProperty2.default)(this, "tokenStorageKey", void 0);
    /**
     * Returns valid token. If token in session storage is not valid then it is removed and function returns null
     */
    (0, _defineProperty2.default)(this, "getToken", () => {
      this.validateStored();
      return this.token.get();
    });
    (0, _defineProperty2.default)(this, "setToken", tokenData => {
      const newStorageValue = {
        ...tokenData
      };
      const userValue = newStorageValue.User;
      const shouldUseFallback = !('User' in newStorageValue) || userValue === undefined || userValue === null || userValue === '';
      if (shouldUseFallback) {
        newStorageValue.User = this.getTokenUser();
      }
      this.token.set(newStorageValue);
      return this;
    });
    this.tokenStorageKey = tokenStorageKey;
    this.token = this.createStorageItem();
  }

  /**
   * Returns true is token storage is for user token
   */
  isForUserToken() {
    return this.tokenStorageKey === _TokenSessionStorageKeys.TokenSessionStorageKeys.USER_ACCESS;
  }

  /**
   * Gets token user which is stored alongside token in storage.
   * If current instance of storage handles user token then this falls back to value inside cookie.
   * Othervise it falls back to default anonymous value
   */
  getTokenUser() {
    const existingUserInsideToken = this.token.get()?.User;
    if (this.isForUserToken()) {
      return _AuthCookies.AuthCookies.getAuthorizedUserValue() ?? existingUserInsideToken;
    }
    return existingUserInsideToken ?? _constants.PUBLIC_TOKEN_USER;
  }

  /**
   * Check for compatibility between whats stored in cookies and whats stored in token
   * These two should be the same
   * This check should also happen when both properties are set (Cookie and <token-from-storage>.User)
   */
  validateStored() {
    const storedData = this.token.get();
    if (!storedData) {
      return;
    }
    let cleanStored = false;
    const cookieValue = _AuthCookies.AuthCookies.getAuthorizedUserValue();
    const isUserToken = this.isForUserToken();

    // 1. Checking for presence both cookie and storedData.User is for backward compatibility with older versions of the @ori/auth package that does not set key User into token storage.
    // Or the user is not logged in or cookies are not supported, e.g. in appshell.
    if (isUserToken && (!cookieValue || !storedData.User)) {
      cleanStored = true;
    }
    // 2. New auth cookie format and mismatch between cookie value and stored user
    else if (isNewAuthCookie(cookieValue) && isUserToken && cookieValue !== storedData.User) {
      cleanStored = true;
    }
    // 3. Expired token
    else if (Date.parse(storedData.ExpirationDate) <= Date.now()) {
      cleanStored = true;
    }
    if (cleanStored) {
      this.token.remove();
    }
  }
  createStorageItem() {
    return new _SessionValue.SessionValue(this.tokenStorageKey);
  }
}
exports.SessionTokenStorage = SessionTokenStorage;
//# sourceMappingURL=SessionTokenStorage.js.map